<script setup>
import IHeader from "@/Layouts/Parts/IHeader.vue"
import IFooter from "@/Layouts/Parts/IFooter.vue"
import GlobalNotifications from "@/Components/GlobalNotifications.vue"
import LSubHeader from "@/Layouts/Parts/LSubHeader.vue"

defineProps({
    cart: {
        type: Boolean,
        default: true
    },
    bgColor: {
        type: String,
        default: "bg-white"
    }
})
</script>

<template>
    <v-app>
        <i-header :cart="cart"/>
        <l-sub-header></l-sub-header>
        <v-main style="--v-layout-top: 0px" :class="{[bgColor]: true}">
            <slot/>
        </v-main>
        <i-footer/>

        <GlobalNotifications/>
    </v-app>
</template>